import { render, staticRenderFns } from "./menuManagement.vue?vue&type=template&id=7b2ee5c0&scoped=true&"
import script from "./menuManagement.vue?vue&type=script&lang=js&"
export * from "./menuManagement.vue?vue&type=script&lang=js&"
import style0 from "./menuManagement.vue?vue&type=style&index=0&id=7b2ee5c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2ee5c0",
  null
  
)

export default component.exports